<div class="sidebar-cta">
  <div class="sidebar-cta-content">
    @if (title) {
      <strong class="d-inline-block mb-2">{{ title }}</strong>
    }
    @if (text) {
      <div class="mb-3 text-sm">{{ text }}</div>
    }

    @if (button) {
      <div class="d-grid">
        <a [routerLink]="button.path" class="btn" [ngClass]="button.classNames ?? ''" target="_blank">{{ button.title }}</a>
      </div>
    }
  </div>
</div>
